import React from 'react'
import { Box, Autocomplete, TextField, Typography } from '@mui/material'
import { useGetEcoAllStock } from '../../api/stock.eco'
import { uniq } from 'lodash'

export const ItemFilter = (props) => {
  const { setItemId, department, itemId } = props
  const itemIdRes = useGetEcoAllStock()

  const itemIdArray = uniq(
    (itemIdRes?.data ?? [])
      .filter((row) => !department || row.department === department)
      .map((row) => row.itemId)
  )

  const handleSelectItemId = (event, value) => {
    setItemId(value)
  }
  return (
    <Box mb={3}>
      {itemIdArray && itemIdArray.length ? (
        <Autocomplete
          disablePortal
          id='item-autocomplete'
          options={itemIdArray}
          sx={{ maxWidth: 650 }}
          onChange={handleSelectItemId}
          size='small'
          renderInput={(params) => <TextField {...params} label='Item' />}
          value={itemId}
          isOptionEqualToValue={(option, value) => option.value === value.value}
        />
      ) : (
        <Typography>No available item</Typography>
      )}
    </Box>
  )
}
